/* eslint-disable no-await-in-loop */
import actionWebInvoke from '../../utils/actionCallUtils';
import actions from '../../config.json';

async function createFolderInAEM(headers, folderTitle, folderPath) {
  const foldercreate = await actionWebInvoke(
    actions['aem-assets-api'],
    headers,
    {
      folderPath,
      folderTitle,
      action: 'foldercreate',
    },
  );
  console.log('testing foldercreate', foldercreate.message);
}

async function getAEMFoldersAndFiles(headers, folderPath) {
  const folderlisting = await actionWebInvoke(
    actions['aem-assets-api'],
    headers,
    // folder path is without content/dam and slash
    { folderPath, action: 'folderlisting' },
  );
  let folderlist = [];
  if (folderlisting.entities) {
    folderlist = folderlisting.entities
      .filter(entity => entity.class.indexOf('assets/folder') !== -1)
      .map(asset => asset.properties.name);
  }
  console.log(
    'folderlisting: lists only folders and not assets',
    folderlisting,
    folderlist,
  );
  return folderlist;
}

async function UploadToFolderinAEM(headers, file, folderPath) {
  console.log('file inside 3 step aem upload process', file);
  const fileName = file.name;
  // braces in filename throws error like My Picks- Preferences(2).png
  fileName.replace(/[()]+/g, '');
  const fileSize = file.size;
  console.log('this is file >>>>>>>>>>>>', fileSize, fileName);

  const initiateupload = await actionWebInvoke(
    actions['aem-assets-api'],
    headers,
    { action: 'initiateupload', fileName, fileSize, folderPath },
  );
  console.log('initiateupload logs', initiateupload);
  const { uploadURIs } = initiateupload.files[0];
  const partSize = initiateupload.files[0].minPartSize;
  const { mimeType } = initiateupload.files[0];
  const { uploadToken } = initiateupload.files[0];
  const { affinitycookie } = initiateupload;
  console.log('uploadURIs length', uploadURIs.length);

  for (let index = 0; index < uploadURIs.length; index++) {
    const uploadUrl = uploadURIs[index];
    const start = index * partSize;
    let end = start + partSize;
    if (end > fileSize) {
      end = fileSize;
    }
    const partBlob = file.slice(start, end);
    console.log(
      `Generate uploading part for file '${fileName}', index: '${index}', file range: '${start} - ${end}', part blob:${partBlob}'`,
    );

    await fetch(uploadUrl, {
      method: 'PUT',
      headers: {
        'Content-Type': mimeType,
      },
      body: partBlob,
    });
  }

  const completeupload = await actionWebInvoke(
    actions['aem-assets-api'],
    headers,
    {
      action: 'completeupload',
      uploadToken,
      mimeType,
      fileName,
      affinitycookie,
      folderPath,
    },
  );
  return completeupload;
}

export {
  getAEMFoldersAndFiles as default,
  createFolderInAEM,
  UploadToFolderinAEM,
};
